<template>
  <div ref="container" style="padding:0 24px;height: 100%;">
    <el-descriptions ref="desc" size="mini" :inline="true" :colon="false" :model="yt.conditions" class="demo-form-inline" :size="100">
      <el-descriptions-item>
        {{ $attrs.material.code + ' | ' + $attrs.material.name + ' | ' + $attrs.material.spec }}
      </el-descriptions-item>
    </el-descriptions>
    <div :style="{ height: tableHeight + 'px' }">
      <!-- table表格 -->
      <yi_curd_table v-bind="$attrs" :name="$t('chanpinshipeigongzhuang')" ref="yt" getUrl="/web/tool/pageByMaterial" @afterGet="afterGet" getKey="rows" :columns="columns">
      </yi_curd_table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableHeight: 0,
      columns: [
        {
          label: 'gongzhuangbianhao',
          prop: 'toolNo'
        },
        {
          label: 'gongzhuangxinghao',
          prop: 'toolSpec'
        },
        {
          label: 'gongzhuangmingcheng',
          prop: 'toolName'
        },
        {
          label: 'suoshuzuzhi',
          prop: 'org.name'
        },
        {
          label: 'gongzhuangleixing',
          prop: 'toolType',
          type: "dictionary",
          key: "CUSTOMER_TOOL_TYPE",
        },
        {
          label: 'guanlifangshi',
          prop: 'manageType',
          type: "dictionary",
          key: "MANAGE_TYPE",
        },
        {
          label: 'chufangweizhi',
          prop: 'location'
        },
        {
          label: 'shuliang',
          prop: 'quantity'
        },
        {
          label: 'danwei',
          prop: 'unit',
          type: "dictionary",
          key: "UNIT_CONVERSION_TYPE",
        },
        {
          label: 'zhizaoshang',
          prop: 'manufacturer'
        },
        {
          label: 'yuanchangxuliehao',
          prop: 'manufacturerNo'
        },
        {
          label: 'zuidashiyongcishu',
          prop: 'lifespanCycles'
        },
        {
          label: 'zuidashiyongshichang(xiaoshi)',
          prop: 'lifespanHours'
        },
        {
          label: 'beizhu',
          prop: 'remark'
        },
      ],
    }
  },
  created() {
    setTimeout(() => {
      this.yt.get(1, this.beforeGet);
    }, 300);
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  methods: {
    beforeGet(params) {
      this.$set(params, 'materialId', this.$attrs.material.id);
      this.$set(params, 'adaptObjectType', 0);
      return params;
    },
    afterGet() {
      for (let i = 0; i < this.yt.list.length; i++) {
        if (this.yt.list[i].materialBindFlag) {
          this.$set(this.yt.list[i], 'source', 1);
        }
        if (this.yt.list[i].mouldBindFlag) {
          this.$set(this.yt.list[i], 'source', 2);
        }
        if (this.yt.list[i].equipmentBindFlag) {
          this.$set(this.yt.list[i], 'source', 3);
        }
      }
    },
    resize() {
      this.$nextTick(() => {
        this.tableHeight = this.$refs.container.offsetHeight - 40 - 33 - 14;
      });
    },
  },
}
</script>

<style scoped>

</style>